import type { Translation } from '../types.ts';
import type en from '../en/discounts.ts';

export default {
    status: {
        active: 'Actief',
        scheduled: 'Gepland',
        expired: 'Verlopen',
        exhausted: 'Opgebruikt',
        disabled: 'Uitgeschakeld',
    },
    shared: {
        enabled: 'Ingeschakeld',
        startsAt: 'Begint op',
        expiresAt: 'Verloopt op',
        expiresHint: 'Leeg = verloopt nooit.',
        searchProducts: 'Zoek producten op naam of SKU…',
        percentOff: '{value}% korting',
        amountOff: '{amount} korting',
    },
    index: {
        title: 'Kortingscodes',
        intro: 'Kortingscodes voor {website}.',
        noWebsite: 'Kies eerst een website om de kortingscodes ervan te beheren.',
    },
    types: {
        percent: 'Percentage korting',
        fixed: 'Vast bedrag korting',
        freeShipping: 'Gratis verzending',
        bogo: 'Koop X, krijg Y',
    },
    list: {
        intro: 'Kortingscodes die klanten in de winkelwagen invullen. Alle bedragen in centen.',
        newCode: 'Nieuwe code',
        empty: 'Nog geen kortingscodes. Maak er een aan om bij het afrekenen korting te geven.',
        typeValue: 'Type / waarde',
        used: 'Gebruikt',
        freeShipping: 'Gratis verzending',
        bogo: 'Koop X, krijg Y',
        confirmDelete: 'Kortingscode "{code}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
        deleted: 'Kortingscode verwijderd',
    },
    edit: {
        newTitle: 'Nieuwe kortingscode',
        editTitle: 'Kortingscode bewerken',
        created: 'Kortingscode aangemaakt',
        saved: 'Kortingscode opgeslagen',
        codePlaceholder: 'ZOMER10',
        codeHint: 'Zichtbaar voor de klant. Wordt in hoofdletters opgeslagen.',
        typeLocked: 'Het type kan na het aanmaken niet meer veranderen.',
        percentOff: 'Percentage korting',
        percentHint: 'Heel percentage, bijv. 10 = 10% korting op het subtotaal.',
        amountOff: 'Korting (centen)',
        amountHint: 'In de valuta van de winkelwagen, bijv. 500 = € 5,00 korting.',
        freeShippingNote: 'Codes voor gratis verzending schrappen de verzendkosten van de bestelling. Er is geen waarde in te stellen.',
        buyQty: 'Aantal kopen (X)',
        getQty: 'Aantal krijgen (Y)',
        rewardIsPercent: 'Beloning is een percentage',
        rewardIsPercentHint: 'Uit = de “krijg”-stuks zijn gratis (100% korting).',
        rewardPercent: 'Kortingspercentage op de “krijg”-stuks',
        rewardPercentHint: '100 = de krijg-stuks zijn gratis.',
        products: 'Geldige producten',
        productsHint: 'Laat producten en categorieën leeg om de korting op de hele winkelwagen toe te passen.',
        removeProduct: 'Product verwijderen',
        categories: 'Geldige categorieën',
        minOrder: 'Minimale bestelling (centen)',
        minOrderHint: 'Subtotaal van de winkelwagen dat nodig is om de code te gebruiken. 0 = geen minimum.',
        maxRedemptions: 'Max. aantal keer te gebruiken',
        unlimited: 'Onbeperkt',
        maxRedemptionsHint: 'Totaal aantal keer gebruik door alle klanten samen. Leeg = onbeperkt.',
        startsHint: 'Leeg = direct beschikbaar.',
        create: 'Code aanmaken',
        save: 'Code opslaan',
    },
    catalog: {
        index: {
            title: 'Cataloguskortingen',
            intro: 'Automatische actie- en staffelprijzen voor {website}.',
            noWebsite: 'Kies eerst een website om de cataloguskortingen ervan te beheren.',
        },
        kinds: {
            sale: 'Actie (vaste korting)',
            volume: 'Staffel (korting op aantal)',
        },
        scopes: {
            product: 'Eén product',
            category: 'Categorie',
        },
        saleAdjustments: {
            percent: 'Percentage korting',
            fixed: 'Vast bedrag korting (centen)',
        },
        tierAdjustments: {
            percent: '% korting',
            fixed: 'Korting (centen)',
            absolute: 'Vaste stukprijs (centen)',
        },
        list: {
            intro: 'Automatische kortingen op producten/categorieën, zonder code. Alle bedragen in centen.',
            newRule: 'Nieuwe regel',
            empty: 'Nog geen prijsregels. Maak een actie- of staffelregel aan om catalogusprijzen automatisch te verlagen.',
            kindValue: 'Soort / waarde',
            appliesTo: 'Geldt voor',
            tiers: 'geen staffels | {n} staffel | {n} staffels',
            confirmDelete: 'Prijsregel "{name}" verwijderen? Dit kan niet ongedaan worden gemaakt.',
            deleted: 'Prijsregel verwijderd',
        },
        edit: {
            newTitle: 'Nieuwe prijsregel',
            editTitle: 'Prijsregel bewerken',
            created: 'Prijsregel aangemaakt',
            saved: 'Prijsregel opgeslagen',
            namePlaceholder: 'Zomeractie – schoenen',
            nameHint: 'Interne naam, zichtbaar in deze lijst.',
            kind: 'Soort',
            kindLocked: 'De soort kan na het aanmaken niet meer veranderen.',
            scope: 'Bereik',
            scopeHint: 'Regels voor een product gaan voor regels voor een categorie.',
            priority: 'Prioriteit',
            priorityHint: 'De hoogste wint als twee regels met hetzelfde bereik van toepassing zijn.',
            product: 'Product',
            clearProduct: 'Product wissen',
            category: 'Categorie',
            discountType: 'Soort korting',
            percentOff: 'Percentage korting',
            percentHint: 'Heel percentage, bijv. 10 = 10% korting op de prijs.',
            amountOff: 'Korting (centen)',
            amountHint: 'Bijv. 500 = € 5,00 korting per stuk.',
            tiers: 'Staffels',
            tiersHint: 'Vanaf het aantal krijgt elk stuk de prijs van die staffel.',
            addTier: 'Staffel toevoegen',
            minQty: 'Min. aantal',
            tierPercent: '% korting',
            tierCents: 'Centen',
            startsHint: 'Leeg = direct actief.',
            create: 'Regel aanmaken',
            save: 'Regel opslaan',
        },
    },
} satisfies Translation<typeof en>;
